// Product classification, not marketing copy such as "토너 포함", determines
// whether the consumable disclosure belongs on this product page.
export function isTonerConsumable(page) {
  const normalize = value => String(value || "").replace(/\s+/g, "").toLowerCase();
  const category = normalize(page?.store_category);
  const devices = new Set(["고속인쇄기", "디지털인쇄기", "대형복합기", "디자인용복합기", "사무용복합기", "소형복합기", "복합기", "프린터"]);
  if (devices.has(category)) return false;
  const consumable = /토너|잉크|드럼|카트리지|소모품|toner|ink|drum|cartridge/i;
  if ([page?.store_category, page?.sub_category, page?.category].some(value => consumable.test(value || ""))) return true;
  const title = `${page?.title || ""} ${page?.model_name || ""}`;
  if ((page?.sale_type === "rental" || page?.sale_type === "both") && /복합기|복사기|프린터/.test(title)) return false;
  return consumable.test(title);
}
